/**
 * Main container
 * imported in App.js
 */
import React, { PureComponent } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import AuthenticatedWrapper from "./AuthenticatedWrapper";
import SignInComponent from "./views/Login/SignInComponent";

const THEME = createMuiTheme({
  typography: {
    fontFamily: "\"Noto Sans\", sans-serif",
  },
});

class App extends PureComponent {
  render() {
    return (
      <ThemeProvider theme={THEME}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/login" component={SignInComponent} />
            <Route path="/" component={AuthenticatedWrapper} />
          </Switch>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
}

export default App;
